module.exports = __webpack_public_path__ + "11_hair_black.5b2ffc64.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/11_hair_black.png
// module id = NRyu
// module chunks = 0